<template>
  <div>
    <va-modal class="modal" :title="'Changer le niveau de relance: ' + nomEntreprise" v-model="showModal"
      :okText="newLevel !== -1 ? 'Sauvegarder' : 'Fermer'" cancelText="Annuler" max-width="100%" v-on:ok="saveLevel"
      v-on:cancel="cancelChange">
      <div class="forcewidth-level">
        <div class="row row-inside">
          <div class="flex md12 mb-4">
            <p>Niveau actuel de l'entreprise:</p>
            <va-badge v-if="level === 0" color="info" class="fullwidth">Niveau 0</va-badge>
            <va-badge v-if="level === 1" color="success" class="fullwidth">Niveau 1</va-badge>
            <va-badge v-if="level === 2" color="warning" class="fullwidth">Niveau 2</va-badge>
            <va-badge v-if="level == 3" color="danger" class="fullwidth">Niveau 3</va-badge>
          </div>

          <div v-if="level === 0" class="flex md12">Aucun envois enregistré pour cette société</div>

          <div v-if="level > 0" class="flex md12">
            <p>Nouveau niveau de relance:</p>
            <va-button v-if="level > 0" :outline="newLevel !== 0" color="info" class="fullwidth mb-2"
              @click="newLevel = 0">Niveau 0</va-button>
            <va-button v-if="level > 1" :outline="newLevel !== 1" color="success" class="fullwidth mb-2"
              @click="newLevel = 1">Niveau 1</va-button>
            <va-button v-if="level > 2" :outline="newLevel !== 2" color="warning" class="fullwidth mb-2"
              @click="newLevel = 2">Niveau 2</va-button>
          </div>
        </div>
      </div>
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["identreprise", "syndicat"],
  data() {
    return {
      nomEntreprise: null,
      showModal: false,
      level: 0,
      newLevel: -1
    };
  },
  methods: {
    async saveLevel() {
      this.showModal = true;
      if (this.newLevel === -1) {
        this.cancelChange();
      } else {
        let params = {
          identreprise: this.identreprise,
          syndicat: this.syndicat,
          newLevel: this.newLevel
        };
        await axios.post("/api/campagnes/change-level", params);
        this.$emit("update", this.identreprise);
        this.showModal = false;
      }
    },
    async loadInfos() {
      this.level = 0;
      this.nomEntreprise = null;
      this.newLevel = -1;
      // get infos envois campagne
      console.log(this.syndicat);
      let res = await axios.get("/api/campagnes/envois-entreprise", {
        params: { identreprise: this.identreprise, syndicat: this.syndicat }
      });
      this.level = res.data.level;
      this.nomEntreprise = res.data.nomEntreprise;
    },

    cancelChange() {
      this.showModal = false;
      this.$emit("cancel", true);
    }
  },
  watch: {
    identreprise(newvalue, oldvalue) {
      console.log("watch identreprise")
      console.log(newvalue);
      if (newvalue) {
        this.loadInfos();
        this.showModal = true;
      }
    }
  }
};
</script>

<style>
.forcewidth-level {
  width: 20vw;
  overflow: hidden;
}

.fullwidth {
  width: 95%;
  padding: 0;
  margin: 0;
}
</style>
